import { createApp } from 'vue'
import HostApp from './HostApp.vue'

// Import compiled Bootstrap with custom variables
import '@/assets/styles/main.scss'

console.log('🎮 Vue Host Interface Starting...')

// Create Vue app
const app = createApp(HostApp)

// Mount the app
app.mount('#app')

console.log('✅ Vue Host Interface Mounted Successfully')